export default __webpack_public_path__ + "static/media/4.a10575cb.png";